(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bnj-information"] && !Shopify.designMode) return;
  try {
    
function initBonneNuitPreorders() {
document.querySelectorAll('.bnj-preorder-form').forEach(form => {
if(form.dataset.preorderReady) return;
form.dataset.preorderReady='true';
const rows=Array.from(form.querySelectorAll('[data-preorder-item]'));
const add=form.querySelector('[data-preorder-add]');
const remove=form.querySelector('[data-preorder-remove]');
if(!add || !remove) return;
let count=1;
add.addEventListener('click',()=>{
if(count>=rows.length) return;
const row=rows[count];row.hidden=false;row.disabled=false;count++;
remove.hidden=false;add.disabled=count===rows.length;
row.querySelector('select').focus();
});
remove.addEventListener('click',()=>{
if(count<=1)return;
const row=rows[count-1];
row.querySelectorAll('select').forEach(s=>s.selectedIndex=0);
row.querySelectorAll('input').forEach(i=>i.value='1');
row.hidden=true;row.disabled=true;count--;
remove.hidden=count===1;add.disabled=false;
});
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBonneNuitPreorders);else initBonneNuitPreorders();
document.addEventListener('shopify:section:load',initBonneNuitPreorders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
